import { resolve } from '@angular/compiler-cli/src/ngtsc/file_system';
import { Component, EventEmitter, Input, OnInit, Output, Testability } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { log } from 'console';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Lang, Res } from 'src/app/models';
import { LanguageService, NotificationService, DatetimeService, ApiCertificatesService, ValidatorsService, ApiOrganizationsService } from 'src/app/services';
import { ApiUserOrgRolesService } from 'src/app/services/api-user-org-roles.service';
import { AttachingCertificateValidator } from '../../certificates/attaching-certificate/attaching-certificate.validator';
import { UserOrgRolesActionsValidator } from './user-org-roles-actions.validators';

@Component({
  selector: 'app-user-org-roles-actions',
  templateUrl: './user-org-roles-actions.component.html',
  styleUrls: ['./user-org-roles-actions.component.css'],
  styles: [``]
})
export class UserOrgRolesActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  orgRoles: any;
  roleId: string;
  modules: any[] = [];
  countSelectedPermission: number;
  permissionsByModule: any;
  // roleName: Lang;
  ffInputLang: any = { name: '', valid: false };
  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }
  permission_date: any[] = [];
  module_ids: any[] = [];
  permission_ids: any[] = [];
  moduleCheckbox: boolean[] = [];
  permissonCheckbox: boolean[] = [];
  currentOrg: any;
  initFormData: any = null;
  permissions: any[] = [];
  action: string;

  @Input() orgRoleId;
  @Input() roleName;

  @Output() applyFormData = new EventEmitter();
  @Output() setRoleName = new EventEmitter();

  form: UntypedFormGroup = this.fb.group({
    urole_in_org_id: [null],
    name: [null, this.validator.name],
    module_id: [null, this.validator.module_id],
    permissions: [null, this.validator.permissions]
  });


  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiUserOrgService: ApiUserOrgRolesService,
    private validator: UserOrgRolesActionsValidator,
    private validatorService: ValidatorsService,
    public config: NgbPopoverConfig,
    private apiOrganizations: ApiOrganizationsService
  ) {
    config.placement = 'left';
    config.triggers = 'hover';
  }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;
    this.currentOrg = this.apiOrganizations.currentOrganization;

    this.getModules();

    this.subscriptions.add(
      this.form.get('module_id').valueChanges.subscribe(val => {

        if (val) {

          this.getPermissions(val);
        }

      })
    );

    this.subscriptions.add(
      this.form.get('permissions').valueChanges.subscribe(val => {

        if (val) {

          console.log("PERMISSIONS: ", val);
          

         setTimeout(() => this.apiUserOrgService.setFValidationData(this.form.value), 300);
        }

      })
    );


    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.subscriptions.add(

      this.apiUserOrgService.listenerActionData().subscribe(val => {

        if (val) {

          this.roleId = val.id
          this.roleName = val.roleName;
          val.action == 'create' ? this.onCreate() : this.onUpdate();
        }

      })
    );

    this.subscriptions.add(

      this.apiUserOrgService.listenerRoleEdit().subscribe(value => {

        if (value) {


          this.initFormData = value;
          this.form.get('module_id').setValue(value.module_id);
          this.form.get('permissions').setValue(value.permissions);

          console.log("ACTION VALUE:", value);
        }
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
  getModules() {

    this.progressRef.start();
    this.loading = true;

    let params = {
      "filter": {}
    }

    this.apiUserOrgService.getReferences(params, 'modules').subscribe((response: Res) => {
      console.log('[RESPONSE] MODULES: ', response);

      if (response != null) {

        this.modules = response.result;

      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   * @param data 
   */
  getPermissions(data: string[] = []) {

    this.progressRef.start();
    this.loading = true;

    this.permissionsByModule = [];


    let params = {
      filter: {
        modules: data
      }
    }

    this.apiUserOrgService.getReferences(params, 'modules_permissions').subscribe((response: Res) => {
      console.log('[RESPONSE] PERMISSONS: ', response);

      if (response.result != null) {

        this.permissionsByModule = response.result;
      }

      this.checkModuleState();

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });

  }


  /**
  * permissonCheckbox
  * @param fieldName string
  * @param value Lang
  */
  eventFnFF(fieldName: string, value: any): void {

    this.ffInputLang = value;

    this.form.controls[fieldName].setValue(value.name);
  }

  /**
   * 
   * @param event 
   * @param id 
   */
  checkModuleState(event: boolean = true, id: string = '') {

    let permissions = this.form.get('permissions').value;

    let permissionArr: any[] = [];

    if(permissions != null && this.permissionsByModule.length > 0){

      for (let pv of permissions) {

        if (!event && pv.module_id != id) {

          for (let pm of this.permissionsByModule) {
  
            if (pv.permission_id == pm.permission_id) {
  
              permissionArr.push(pm);
  
            }
          }
  
        } else {
  
          for (let pm of this.permissionsByModule) {
  
            if (pv.permission_id && pv.permission_id == pm.permission_id) {
  
              permissionArr.push(pm);
  
            }
  
            if (pv == pm.permission_id) {
  
              permissionArr.push(pm);
            }
          }
        }
  
      }
    }

    this.form.get('permissions').setValue(permissionArr);
    this.form.updateValueAndValidity();
    this.apiUserOrgService.setFValidationData(this.form.value);

  }

  /**
   * 
   */
  onCreate(): void {

    let form = { ...this.form.value }

    form['id'] = this.roleId;
    form['name'] = this.roleName;
    form['permissions'] = [...new Set(form.permissions.map(({ permission_id }) => permission_id))];

    this.progressRef.start();

    console.log("ROLE CREATE FORM: ", form);


    this.subscriptions.add(
      this.apiUserOrgService.create(form).subscribe((response: Res) => {
        console.log('[RESPONSE] saveCertificate: ', response);

        if (response != null) {

          this.apiUserOrgService.setRoleId(response.result.id);
          this.notification.show('success', 'Роль успешно создана!');
          // this.applyFormData.emit(response);
          // this.activeModal.close(response.result);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value }

    form['id'] = this.roleId;
    form['name'] = this.roleName;
    form['permissions'] = [...new Set(form.permissions.map(({ permission_id }) => permission_id))];
    
    this.progressRef.start();

    this.subscriptions.add(
      this.apiUserOrgService.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          // this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


}
